// Shared option builder for every GL / overhead account picker.

const ownName = (a) => {
  const full = a?.name || "";
  const i = full.lastIndexOf(":");
  return i === -1 ? full : full.slice(i + 1).trim();
};

const parentFullName = (a) => {
  const full = a?.name || "";
  const i = full.lastIndexOf(":");
  return i === -1 ? "" : full.slice(0, i).trim();
};

const numOrNull = (a) => {
  const n = parseFloat(a?.account_number);
  return Number.isFinite(n) ? n : null;
};

export const compareGlAccounts = (a, b) => {
  const na = numOrNull(a);
  const nb = numOrNull(b);
  if (na !== null && nb !== null && na !== nb) return na - nb;
  if (na !== null && nb === null) return -1;
  if (na === null && nb !== null) return 1;
  return ownName(a).localeCompare(ownName(b));
};

export const glLineOne = (a) => `${a.account_number ? `${a.account_number} · ` : ""}${ownName(a)}`;

/**
 * Build SearchableSelect items for GL accounts.
 *   accounts: candidates for the list
 *   allAccounts: full account list used to find parents (defaults to accounts)
 *   selectedIds: saved values that must stay visible even when inactive/filtered
 *   visibleOnly: also hide accounts the admin flagged hidden
 *   filter: extra predicate (e.g. only Bank / Credit Card)
 */
export function buildGlItems(accounts, { allAccounts, selectedIds = [], visibleOnly = false, filter } = {}) {
  const pool = allAccounts && allAccounts.length ? allAccounts : accounts || [];
  const byFullName = new Map(pool.map((a) => [a.name, a]));
  const keep = new Set(selectedIds.filter(Boolean));
  const seen = new Set();
  const rows = [];
  const consider = (a) => {
    if (!a || seen.has(a.id)) return;
    const inactive = a.active === false;
    const listed = !inactive && (!visibleOnly || a.visible !== false) && (!filter || filter(a));
    if (!listed && !keep.has(a.id)) return;
    seen.add(a.id);
    rows.push({ a, inactive });
  };
  (accounts || []).forEach(consider);
  pool.filter((a) => keep.has(a.id)).forEach(consider);
  rows.sort((x, y) => compareGlAccounts(x.a, y.a));
  return rows.map(({ a, inactive }) => {
    const parentName = parentFullName(a);
    const parent = parentName ? byFullName.get(parentName) : null;
    const parentText = parent
      ? `${parent.account_number ? `${parent.account_number} ` : ""}${ownName(parent)}`
      : ownName({ name: parentName });
    return {
      value: a.id,
      label: `${glLineOne(a)}${inactive ? " (inactive)" : ""}`,
      sublabel: parentText ? `Sub-account of ${parentText}` : "",
      searchText: `${a.account_number || ""} ${ownName(a)} ${parentName} ${parent ? ownName(parent) : ""} ${a.account_type || ""}`,
    };
  });
}
